// extracted by mini-css-extract-plugin
module.exports = {"container":"Details_container__3DuT5","content":"Details_content__2D4gS","list":"Details_list__565ml","list_item":"Details_list_item__zrfxI"};